import { connect } from 'react-redux';
import { toggleMobileMenu, toggleCollapsingMenu } from 'redux/actions/layoutActions';
import Topbar from './Topbar';

const mapStateToProps = ({ layout }) => {
    const { admin, locale, menuCollapsed, userPermissions } = layout;
    return { admin, locale, menuCollapsed, userPermissions };
};

export default connect(mapStateToProps, { toggleMobileMenu, toggleCollapsingMenu })(Topbar);
